
import { Component, Vue } from 'vue-property-decorator'

@Component({
    inheritAttrs: false,
})
export default class VImageWrapper extends Vue {
    loadingImage = true
    errorImage = false

    onImageLoad() {
        this.loadingImage = false
        this.errorImage = false
    }

    onImageError() {
        this.loadingImage = false
        this.errorImage = true
    }
}
